import API from "@utils/plugins/API";

const WinchTypeService = {
  all: (params) => {
    return API.get("winch-types", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("winch-types", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`winch-types/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`winch-types/${id}`);
  },
  destroy: (id) => {
    return API.delete(`winch-types/${id}`);
  },
};

export default WinchTypeService;
